(function ($) {


  $(document).ready(function () {

    responsiveGuarantee();
    homepageSlider.init();
    // productGallery.init();
    // productFrameSize.init();
    // productColour.init();
    footer.init();
    inputNumberReplacement.init();
    bikeTabs.init();
    bikeDiagram.init();
    hashScrolls.init();
    stickyHeader.init();
    bannerCarousel.init();
    pageTabs.init();

    $(document.body).on('updated_cart_totals', function () {
      inputNumberReplacement.init();
    });

    function scale() {
      return document.body.clientWidth / window.innerWidth;
    }

    if ($('body.cart').length) {
      $('.checkout-agreement input').iCheck({
        checkboxClass: 'icheckbox_square',
        radioClass: 'icheckbox_square',
        radioClass: 'icheckbox_square',
        increaseArea: '20%' // optional
      });
    }

    if ($('.my-account').length) {
      $('input').iCheck({
        checkboxClass: 'icheckbox_square',
        radioClass: 'icheckbox_square',
        radioClass: 'icheckbox_square',
        increaseArea: '20%' // optional
      });
    }

    /**
     * Navigation overlay
     */

    $('.mobile-trigger').click(function () {

      var menu = $('.nav-mobile'),
        body = $('body'),
        navBtn = $(this);

      if (menu.hasClass('on')) {
        menu.removeClass('on');
        body.removeClass('noscroll');
      } else {
        menu.addClass('on');
        body.addClass('noscroll');
        navBtn.addClass('fade');
      }

    });

    $('.menu-close').click(function () {

      var menu = $('.nav-mobile'),
        body = $('body'),
        navBtn = $(this);

      if (menu.hasClass('on')) {
        menu.removeClass('on');
        body.removeClass('noscroll');
      }

    });

    if ($('.marquee').length) {
      $('.marquee').marquee({
        duration: 15000,
        gap: 50,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true,
        pauseOnHover: true
      });
    }

  });

  $(window).load(function () {

    if ($('.news-wrapper').length) {
      $('.news-wrapper').masonry({
        itemSelector: 'article',
        gutter: 50
      });
    }

  });

  var googleMap = {
    init: function () {

      // Basic options for a simple Google Map
      // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
      var mapOptions = {
        // How zoomed in you want the map to start at (always required)
        zoom: 14,
        streetViewControl: false,


        // The latitude and longitude to center the map (always required)
        center: new google.maps.LatLng(51.542764, -0.147922), // New York
        // How you would like to style the map.
        // This is where you would paste any style found on Snazzy Maps.
        styles: [{
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "color": "#e9e9e9"
          }, {
            "lightness": 17
          }]
        }, {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [{
            "color": "#f5f5f5"
          }, {
            "lightness": 20
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#ffffff"
          }, {
            "lightness": 17
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": "#ffffff"
          }, {
            "lightness": 29
          }, {
            "weight": 0.2
          }]
        }, {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [{
            "color": "#ffffff"
          }, {
            "lightness": 18
          }]
        }, {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [{
            "color": "#ffffff"
          }, {
            "lightness": 16
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [{
            "color": "#f5f5f5"
          }, {
            "lightness": 21
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [{
            "color": "#dedede"
          }, {
            "lightness": 21
          }]
        }, {
          "elementType": "labels.text.stroke",
          "stylers": [{
            "visibility": "on"
          }, {
            "color": "#ffffff"
          }, {
            "lightness": 16
          }]
        }, {
          "elementType": "labels.text.fill",
          "stylers": [{
            "saturation": 36
          }, {
            "color": "#333333"
          }, {
            "lightness": 40
          }]
        }, {
          "elementType": "labels.icon",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [{
            "color": "#f2f2f2"
          }, {
            "lightness": 19
          }]
        }, {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#fefefe"
          }, {
            "lightness": 20
          }]
        }, {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": "#fefefe"
          }, {
            "lightness": 17
          }, {
            "weight": 1.2
          }]
        }]
      };

      // Get the HTML DOM element that will contain your map
      // We are using a div with id="map" seen below in the <body>
      var mapElement = document.getElementById('googleMap');

      // Create the Google Map using our element and options defined above
      var map = new google.maps.Map(mapElement, mapOptions);

      // Let's also add a marker while we're at it
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(51.542764, -0.147922),
        map: map,
        title: 'Snazzy!',
        icon: '/wp-content/themes/goldhawk/assets/images/marker.png' // null = default icon
      });
    }

  }

  var pageTabs = {
    carouselId: '.page-tabs',
    init: function () {
      if ($(this.carouselId).length) {
        $(this.carouselId).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          fade: true,
          draggable: false,
          autoplay: false,
          cssEase: 'linear',
          pauseOnHover: false,
          customPaging: function (slider, i) {
            var pagerTitle = $(slider.$slides[i]).data('tab-title');
            return '<a>' + pagerTitle + '</a>';
          }
        });
        $(".slick-dots").wrap("<div class=\"slick-dots-container\"></div>");
      }
    }
  }

  var bannerCarousel = {
    carouselId: '.page-carousel',
    init: function () {
      $(bannerCarousel.carouselId).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        fade: true,
        draggable: false,
        autoplay: true,
        autoplaySpeed: 6000,
        cssEase: 'linear',
        pauseOnHover: false,
        speed: 600

      });
    }
  }

  var hashScrolls = {
    headerHeight: 125,
    init: function () {
      this.onClick();
      this.onLoad();
    },
    onClick: function () {
      var anchors = document.querySelectorAll('a');
      for (var z = 0; z < anchors.length; z++) {
        anchors[z].addEventListener('click', function () {
          var elem = document.getElementById(this.hash.substr(1));
          if (elem) {
            if (elem.classList.contains('swatch-anchor')) {
              return;
            }
            var elemPos = getOffset(elem).top - hashScrolls.headerHeight * 2.5;
            scrollToY(elemPos, 1500, 'easeInOutQuint');
          }
        }, false);
      }
    },
    onLoad: function () {
      var hash = window.location.hash;
      if (hash) {
        // First find the yPos of the hash elem so we can pass this into our scroll function
        window.onload = function () {
          var elem = document.getElementById(hash.substr(1));
          var elemPos = getOffset(elem).top - hashScrolls.headerHeight * 2.5;
          scrollToY(elemPos, 1500, 'easeInOutQuint');
        }
      }
    }
  }

  var stickyHeader = {
    init: function () {
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 51) {
          $('.nav-bar').addClass('fixed-header');
          $('.sticky-header-spacer').addClass('active');
        } else {
          $('.nav-bar').removeClass('fixed-header');
          $('.sticky-header-spacer').removeClass('active');
        }
      });
    }
  }

  var bikeDiagram = {
    numberWrapper: '.diagram-number-wrapper',
    diagramText: '.diagram-text',
    init: function () {
      $(this.numberWrapper).on('click', function () {
        $('.diagram-marker-wrapper').removeClass('active');
        $(this).parent().toggleClass('active');
      });
      $('body').on('touchend', function (event) {
        if ($(event.target).closest('.diagram-marker-wrapper').length)
          return;
        $('.diagram-marker-wrapper').removeClass('active');
      });
    }
  }

  function responsiveGuarantee() {
    var expanded = false;
    var expand_class_name = 'expanded';
    var position_class_name = 'expanded-position';
    var columns_expandable = $('.columns-expandable').get(0);
    var title = $('.guarantee-title').get(0);
    var strip = $('.goldhawk-guarantee').get(0);
    var button = $('.guarantee-button').get(0);

    if ($('.goldhawk-guarantee').hasClass('expanded')) {
      expanded = true;
    }

    $('.guarantee-button').click(function () {

      if (expanded) {
        columns_expandable.classList.remove(expand_class_name);
        setTimeout(function () {
          // $('.columns-expandable').css('display', 'none');
        }, 850);
        columns_expandable.classList.remove(position_class_name);
        title.classList.remove(expand_class_name);
        strip.classList.remove(expand_class_name);
        button.classList.remove(expand_class_name);
        expanded = false;
      } else {
        $('.columns-expandable').css('display', 'flex');

        setTimeout(function () {
          columns_expandable.classList.add(expand_class_name);
          columns_expandable.classList.add(position_class_name);
          title.classList.add(expand_class_name);
          strip.classList.add(expand_class_name);
          button.classList.add(expand_class_name);
        }, 100);

        expanded = true;
      }

    });
  }

  var bikeTabs = {
    pageIdentifier: 'body.page-id-511',
    init: function () {
      this.autoSelectTab();
      this.mobileSelectTab();
    },
    autoSelectTab: function () {
      if (window.location.hash && $(bikeTabs.pageIdentifier).length) {
        var hash = window.location.hash.substring(1);
        $('.js-tablist__link[aria-controls=' + hash + ']').trigger('click');
      }
    },
    mobileSelectTab: function () {
      if ($(bikeTabs.pageIdentifier).length) {
        $('.js-tabcontent h2').on('click', function () {
          $('.js-tabcontent').removeClass('on');
          $(this).parent().toggleClass('on');
          var position = $(this).position().top;
          if ($('#wpadminbar').length) {
            position = position - $('#wpadminbar').height();
          }
          scrollToY(position, 1500, 'easeInOutQuint');
        });
      }
    }
  }

  var footer = {
    init: function () {
      $('.button--open-footer').on('click', function () {
        $('body').toggleClass('footer-active');
        googleMap.init();
      });
      $(document).on('click touchend', function (event) {
        if (!$(event.target).closest('.site-footer').length) {
          if ($('body').hasClass('footer-active')) {
            $('body').removeClass('footer-active');
          }
        }
      });
    }
  }

  var inputNumberReplacement = {
    init: function () {
      if ($('.quantity-nav').length == 0) {
        $('<div class="quantity-nav"><div class="quantity-button product-quantity-up"><span class="chevron top"></span></div><div class="quantity-button product-quantity-down"><span class="chevron down"></span></div></div>').insertAfter('.quantity input');
        $('.quantity').each(function () {
          var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.product-quantity-up'),
            btnDown = spinner.find('.product-quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');

          btnUp.click(function () {
            var oldValue = parseFloat(input.val());
            var newVal = oldValue + 1;

            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
          });

          btnDown.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
              var newVal = oldValue;
            } else {
              var newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
          });

        });
      }
    }
  }

  // var productColour = {
  //   init: function () {
  //     this.defaultSelection();
  //   },
  //   defaultSelection: function () {
  //     $('#radio-432-colour-00').prop("checked", true);
  //   }
  // }

  // var productFrameSize = {
  //   init: function () {
  //     setTimeout(function () {

  //       $('#radio-432-frame-size-10').click();
  //       var tooltip = $('#radio-432-frame-size-10').next().find('span').data('tooltip');

  //       $('.tooltip.frame-size').html(tooltip).addClass('active');
  //       $('.product-addon-frame-size input:radio').on('change', function () {
  //         var tooltip = $(this).next().find('span').data('tooltip');
  //         $('.tooltip.frame-size').html(tooltip).addClass('active');
  //       });

  //     }, 1000);
  //   }
  // }

  // var productGallery = {
  //   init: function () {
  //     if ($('.product-carousel--main').length) {
  //       this.carousel();
  //       this.zoomInit();
  //       this.zoomUpdate();
  //     }
  //   },
  //   carousel: function () {
  //     $('.product-gallery.red .product-carousel--main').slick({
  //       lazyLoad: 'ondemand',
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       fade: true,
  //       asNavFor: '.product-carousel--thumb'
  //     });
  //     $('.product-gallery.red  .product-carousel--thumb').slick({
  //       lazyLoad: 'ondemand',
  //       slidesToShow: $('.thumb-image.slide-color-red').length + '.2',
  //       slidesToScroll: 1,
  //       asNavFor: '.product-gallery.red .product-carousel--main',
  //       dots: true,
  //       focusOnSelect: true

  //     });
  //     $('.product-gallery.grey .product-carousel--main').slick({
  //       lazyLoad: 'ondemand',
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       fade: true,
  //       asNavFor: '.product-carousel--thumb'
  //     });
  //     $('.product-gallery.grey  .product-carousel--thumb').slick({
  //       lazyLoad: 'ondemand',
  //       slidesToShow: $('.thumb-image.slide-color-grey').length + '.04',
  //       slidesToScroll: 1,
  //       asNavFor: '.product-gallery.grey .product-carousel--main',
  //       dots: true,
  //       focusOnSelect: true

  //     });

  //     $(document).ready(function () {
  //       $('body').addClass('red-carousel').removeClass('grey-carousel');
  //     });

  //     $('.product-addon-colour input[type=radio]').change(function () {
  //       if (this.value == 'sprint-red') {
  //         $('body').addClass('red-carousel').removeClass('grey-carousel');
  //         $('.product-carousel--main').slick('refresh');
  //         $('.product-carousel--thumb').slick('refresh');
  //       } else if (this.value == 'flint-grey') {
  //         $('body').addClass('grey-carousel').removeClass('red-carousel');
  //         $('.product-carousel--main').slick('refresh');
  //         $('.product-carousel--thumb').slick('refresh');
  //       }

  //     });
  //   },
  //   zoomInit: function () {
  //     if (!is_touch_device()) {
  //       $('div.zoom').zoom({
  //         url: $(this).find('img').attr('data-src'),
  //         touch: false,
  //         on: 'mouseover'
  //       });
  //     }
  //   },
  //   zoomUpdate: function () {
  //     $('.product-carousel--main').on('afterChange', function () {
  //       $('div.zoom').trigger('zoom.destroy');
  //       productGallery.zoomInit();
  //     });
  //   }
  // }

  var homepageSlider = {
    init: function () {
      if ($('.slider-images').length) {
        var homeSliders = $(".slider-images");
        homeSliders.on('init', function () {
          $(homeSliders).each(function () {
            $(this).addClass('on');
          });
        });
        $(homeSliders).each(function (idx, item) {
          var carouselId = "slider_" + idx;
          this.id = carouselId;
          $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            fade: true,
            draggable: false,
            autoplay: false,
            autoplaySpeed: 6000,
            cssEase: 'linear',

          });
        });

      }
    }
  }

  function responsiveHomepage() {
    if ($('.slider-images').css('float') === 'none') {
      $('.home-row').each(function () {
        $new_position = $(this).find('.container .mobile-text');
        $(this).find('h2').prependTo($new_position);
      });
    } else {
      $('.home-row').each(function () {
        $new_position = $(this).find('.container .text');
        $(this).find('h2').prependTo($new_position);
      });
    }
  }

  function is_touch_device() {
    return 'ontouchstart' in window;
  }

  // first add raf shim
  // http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
  window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
  })();

  // main function
  function scrollToY(scrollTargetY, speed, easing) {
    // scrollTargetY: the target scrollY property of the window
    // speed: time in pixels per second
    // easing: easing equation to use

    var scrollY = window.scrollY,
      scrollTargetY = scrollTargetY || 0,
      speed = speed || 2000,
      easing = easing || 'easeOutSine',
      currentTime = 0;

    // min time .1, max time .8 seconds
    var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

    // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
    var PI_D2 = Math.PI / 2,
      easingEquations = {
        easeOutSine: function (pos) {
          return Math.sin(pos * (Math.PI / 2));
        },
        easeInOutSine: function (pos) {
          return (-0.5 * (Math.cos(Math.PI * pos) - 1));
        },
        easeInOutQuint: function (pos) {
          if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(pos, 5);
          }
          return 0.5 * (Math.pow((pos - 2), 5) + 2);
        }
      };

    // add animation loop
    function tick() {
      currentTime += 1 / 60;

      var p = currentTime / time;
      var t = easingEquations[easing](p);

      if (p < 1) {
        requestAnimFrame(tick);

        window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
      } else {
        window.scrollTo(0, scrollTargetY);
      }
    }

    // call it once to get started
    tick();
  }

  function getOffset(el) {
    if (el) {
      el = el.getBoundingClientRect();
      return {
        left: el.left + window.scrollX,
        top: el.top + window.scrollY
      }
    }
    return false;
  }


})(jQuery); // Fully reference jQuery after this point.
